import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";

import ContentSpinner from "@/components/ContentSpinner";
import { PageHeading } from "@/components/Layout/Parts";
import Text from "@/components/Text";
import useAlerts from "@/hooks/useAlerts";
import { SerpSearchResource } from "@/types/resources";
import { api } from "@/utils/api";
import BackButton from "@/components/BackButton";
import ImagesTable from "./components/ImagesTable";

const StyledPageHeading = styled(PageHeading)`
  max-width: 800px;
`;

const InstagramImagesSingle = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const alerts = useAlerts();

  const { isLoading, data: searchData } = useQuery<SerpSearchResource>(
    ["instagram_searches_list", { id }],
    () =>
      api.get<never, SerpSearchResource>(`/v1/instagram-images-searches/${id}`),
    {
      staleTime: 60 * 1000,
      retry: 2,
      onError: (err) => {
        if ((err as any).response.status === 404) {
          return navigate("/404", {
            replace: true,
          });
        }
        alerts.error();
      },
    }
  );

  if (isLoading || !searchData) {
    return <ContentSpinner />;
  }

  return (
    <>
      <Text $color="gray" $type="caption">
        INSTAGRAM IMAGES SERP
      </Text>
      <StyledPageHeading>{searchData.name}</StyledPageHeading>
      <BackButton />
      <ImagesTable />
    </>
  );
};

export default InstagramImagesSingle;
